import { ActivityState, Maybe } from '@iss/libs/graphql';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { OrderStateComponent } from '../order-state';

@Component({
  selector: 'wo-active-state',
  templateUrl: './active-state.component.html',
  styleUrls: [ './active-state.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    OrderStateComponent,
  ],
})
export class ActiveStateComponent {
  public readonly ActivityState = ActivityState;

  @Input() public active: Maybe<boolean>;
  @Input() public small: Maybe<boolean>;
}
